import { RowGroup } from './RowGroup'

export const TBodyCustom = ({
  typeComponent,
  ids,
  schema,
  selectRowGroup,
  selectCellData,
  isDynamicReport,
  compareVal,
}) => {
  return (
    <tbody>
      {ids.map((rowId, index) => {
        return (
          <RowGroup
            key={rowId}
            schema={schema}
            rowId={rowId}
            rowGroupIndex={index}
            selectRowGroup={selectRowGroup}
            selectCellData={selectCellData}
            isDynamicReport={isDynamicReport}
            typeComponent={typeComponent}
            compareVal={compareVal}
          />
        )
      })}
    </tbody>
  )
}
